'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;
// import { isLoaded as isInfoLoaded, load as loadInfo } from 'redux/modules/info';
// import { isLoaded as isAuthLoaded, load as loadAuth } from 'redux/modules/auth';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _address = require('redux/modules/address');

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _analytics = require('redux/modules/analytics');

var analyticsActions = _interopRequireWildcard(_analytics);

var _reactRouterRedux = require('react-router-redux');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _notification = require('redux/modules/notification');

var notificationActions = _interopRequireWildcard(_notification);

var _reduxAsyncConnect = require('redux-async-connect');

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _AnalyticService = require('helpers/AnalyticService');

var _AnalyticService2 = _interopRequireDefault(_AnalyticService);

var _localStorage = require('utils/localStorage');

var _lodash = require('lodash');

var _lib = require('helpers/lib');

var _CampaignTracking = require('helpers/CampaignTracking');

var _DownloadAppPopup = require('components/Mobile/Common/DownloadAppPopup');

var _DownloadAppPopup2 = _interopRequireDefault(_DownloadAppPopup);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Helper } from 'helpers/support';
var routeNoHeader = ['dang-nhap', 'register', 'forgot-pass', 'reset-pass', 'active-account', 'new-password', 'tai-khoan', 'not-found', 'kol', 'tao-cua-hang', 'uu-dai-cua-toi', 'khuyen-mai'];
var routeNoFooter = ['dang-nhap', 'register', 'chinh-sua-tai-khoan', 'danh-gia', 'tao-cua-hang', 'reset-pass', 'new-password', 'active-account', 'enterprise', 'kol', 'dat-lich', 'dat-lich-2', 'dat-lich-3', 'uu-dai', 'uu-dai-cua-toi', 'uu-dai-cham-soc-da-massage', 'uu-dai-lam-toc-mong', 'uu-dai-tham-my-vien', 'uu-dai-phong-kham', 'uu-dai-the-duc-the-thao', 'uu-dai-xam-hinh', 'quan-ly-dat-cho', 'phuong-thuc-thanh-toan', 'dich-vu-tai-nha', 'uu-dai-trai-nghiem', 'uu-dai-5-sao', 'uu-dai-toi', 'dich-vu'];
// const routeNoHeader = [];

// import { Helper } from 'helpers/support';

// import Images from 'helpers/Images';

var AppMobile = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    // if (!isInfoLoaded(getState())) {
    //   promises.push(dispatch(loadInfo()));
    // }
    // if (!isSetupLoaded(getState())) {
    //   promises.push(dispatch(loadCategory()));
    // }
    // if (!isAuthLoaded(getState())) {
    //   promises.push(dispatch(loadAuth()));
    // }
    if (!(0, _address.isLoaded)(getState())) {
      promises.push(dispatch((0, _address.loadProvinceServer)()));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    pathname: state.setup.pathname,
    filterFullScreen: state.filter.filterFullScreen,
    configHeader: state.setup.configHeader,
    categories: state.setup.categories,
    notifications: state.notification.notifications,
    REWARD_CAMPAIGN: state.voucher.REWARD_CAMPAIGN,
    PACKAGE_DETAIL: state.voucher.PACKAGE_DETAIL
  };
}, (0, _extends3.default)({}, userActions, authActions, notificationActions, {
  pushState: _reactRouterRedux.push,
  changeHeader: setupActions.changeHeader,
  loadCat: setupActions.loadCat,
  manualTrack: analyticsActions.manualTrack,
  setPathName: _setup.setPathName
})), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(AppMobile, _Component);

  function AppMobile(props) {
    (0, _classCallCheck3.default)(this, AppMobile);

    var _this = (0, _possibleConstructorReturn3.default)(this, (AppMobile.__proto__ || (0, _getPrototypeOf2.default)(AppMobile)).call(this, props));

    _this.notiChecking = function () {
      var notifications = _this.props.notifications;

      _this.props.loadNotification();
      if (notifications) {
        notifications.map(function (value) {
          if (value.read === false) {
            _this.setState({
              noti: !false
            });
          }
        });
      }
    };

    _this.componentDidMount = function () {
      _AnalyticService2.default.setUniqueId();
      _AnalyticService2.default.setUTM();
      window.addEventListener('scroll', _this.scrollToHandleBanner, true);
      // TODO chỉnh lại login fb desktop/mobile
      window.fbAsyncInit = function () {
        window.FB.init({
          appId: _config2.default.fbAppId,
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v3.0'
        });
        window.FB.Event.subscribe('auth.statusChange', function (response) {
          if (response.authResponse) {
            _this.props.loginFacebook(response.authResponse.accessToken);
          } else {
            // this.updateLoggoutState();
          }
        });
      };
      (function (d, s, id) {
        var js,
            fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = '//connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
      // TODO localStore
      if ((0, _localStorage.localStore)().get('token')) {
        _this.props.loadAuth();
        _this.notiChecking();
      } else {
        _this.props.setUser(null);
      }
      // if (navigator.geolocation) {
      //   navigator.geolocation.getCurrentPosition(position => {
      //     this.props.saveUserLocation(position.coords);
      //   });
      // }
      if (_this.props.user && _this.props.pathname && _this.props.pathname.indexOf('dang-nhap') === -1 && _this.props.pathname.indexOf('register') === -1) {
        _this.props.pushState(_this.props.pathname);
        _this.props.setPathName('');
      }
    };

    _this.onCloseBanner = function () {
      var dateNow = (0, _moment2.default)().format('YYYY-MM-DD');
      (0, _localStorage.localStore)().set('headerBannerHiddenDate', dateNow);
      _this.setState({ hasBanner: false });
      _this.bannerHidden = true;
    };

    _this.onClosePopupImage = function () {
      var dateNow = (0, _moment2.default)().format('YYYY-MM-DD');
      (0, _localStorage.localStore)().set('popUpImageHiddenDate', dateNow);
      _this.setState({ showPopupImage: false });
      _this.popUpImageHidden = true;
    };

    var initialState = {
      filterFullScreen: _this.props.filterFullScreen,
      routes: [],
      home: _this.props.location && (_this.props.location.pathname === '/' || _this.props.location.pathname === '/') ? true : false,
      loginReg: _this.props.location && (_this.props.location.pathname === '/dang-nhap' || _this.props.location.pathname === '/register' || _this.props.location.pathname.indexOf('reset-pass') !== -1 || _this.props.location.pathname.indexOf('new-password') !== -1 || _this.props.location.pathname.indexOf('active-account') !== -1) ? true : false,
      hasFooter: true,
      hasHeader: true,
      onlyBanner: false,
      focus: false,
      hasBanner: true,
      noti: false,
      showPopupImage: true
    };
    // check if pop-up banner is hidden for today
    _this.popUpImageHidden = false;
    var popUpImageDate = (0, _localStorage.localStore)().get('popUpImageHiddenDate');
    if (popUpImageDate) {
      var now = (0, _moment2.default)().format('YYYY-MM-DD');
      if (now === popUpImageDate) {
        initialState.showPopupImage = false;
        _this.popUpImageHidden = true;
      }
    }

    // Check if banner is hidden for today
    _this.bannerHidden = false;
    var bannerHiddenDate = (0, _localStorage.localStore)().get('headerBannerHiddenDate');
    if (bannerHiddenDate) {
      var _now = (0, _moment2.default)().format('YYYY-MM-DD');
      if (_now === bannerHiddenDate) {
        initialState.hasBanner = false;
        _this.bannerHidden = true;
      }
    }
    _this.state = initialState;

    _this.scrollToHandleBanner = _this.scrollToHandleBanner.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(AppMobile, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // TODO Kiểm tra header footer lần đầu load
      var _props = this.props,
          location = _props.location,
          history = _props.history,
          changeHeader = _props.changeHeader,
          categories = _props.categories,
          PACKAGE_DETAIL = _props.PACKAGE_DETAIL;

      if (!categories) {
        this.props.loadCat();
      }
      if (location && location.pathname) {
        var listPath = location.pathname.split('/');
        var firstPathComponent = '';
        if (listPath.length > 1) {
          firstPathComponent = listPath[1];
        }
        if (listPath[2] === 'danh-gia') {
          var hasFooter = routeNoFooter.indexOf(listPath[2]) === -1;
          var hasHeader = routeNoHeader.indexOf(firstPathComponent) === -1;
          this.setState({ hasHeader: hasHeader, hasFooter: hasFooter });
        } else if (listPath[1] === 'uu-dai' && listPath.length === 3 && PACKAGE_DETAIL.data) {
          var _hasFooter = routeNoFooter.indexOf(firstPathComponent) === -1;
          this.setState({ hasHeader: true, hasFooter: _hasFooter, onlyBanner: true });
        } else if (listPath[1] === 'khuyen-mai') {
          var _hasFooter2 = routeNoFooter.indexOf(firstPathComponent) === -1;
          this.setState({ hasHeader: true, hasFooter: _hasFooter2, onlyBanner: true });
        } else {
          var _hasFooter3 = routeNoFooter.indexOf(firstPathComponent) === -1;
          var _hasHeader = routeNoHeader.indexOf(firstPathComponent) === -1;
          this.setState({ hasHeader: _hasHeader, hasFooter: _hasFooter3 });
        }
        if (this.props.location.query && this.props.location.query.hideHeader) {
          this.setState({
            hasFooter: false,
            hasHeader: false,
            onlyBanner: false
          });
        }
      }
      this.unlisten = history.listen(function (loca, action) {
        if (action && action.routes && action.routes[action.routes.length - 1].page) {
          changeHeader(action.routes[action.routes.length - 1].page);
        }
      });
      if (location && location.search && location.search.length > 0) {
        (0, _CampaignTracking.setTrackingParams)(location.search);
      }
    }
    // check có noti hay k

  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.scrollToHandleBanner, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var configHeader = this.props.configHeader;
      // Đã có thông tin login hay chưa?

      if (!(0, _lodash.isEqual)(this.props.user, nextProps.user) && nextProps.user !== null) {
        // Quay về trang trước khi login
        if (this.props.pathname && this.props.pathname.indexOf('dat-lich-3') === -1 && this.props.pathname.indexOf('dang-nhap') === -1 && this.props.pathname.indexOf('register') === -1 && nextProps.user.profile.name !== '') {
          this.notiChecking();
          this.props.pushState(this.props.pathname);
          this.props.setPathName('');
        } else if (!this.props.pathname && nextProps.user.profile.name !== '' && (!this.props.location.pathname || this.props.location.pathname.indexOf('dat-lich-3') === -1)) {
          // Trường hợp đã login và user đã có tên rồi, mà không có pathname trước đó thì phải quay lại trang chủ, trừ trường hợp khi đang ở đặt lịch 2.
          if (this.props.location.pathname.indexOf('dat-lich-2') === -1) {
            console.log('AppMobile VỀ TRANG CHỦ');
            this.props.pushState('/');
          }
        }
        // pathname để back lại trang trước, trước khi qua login/register thì phải set pathname
      } else if (this.props.user && !nextProps.user) {
        // logout
        console.log('AppMobile VỀ TRANG CHỦ');
        this.props.pushState('/');
      }
      if (this.props.filterFullScreen !== nextProps.filterFullScreen) {
        this.setState({ filterFullScreen: nextProps.filterFullScreen });
      }
      // xét xem trang kế tiếp có cần footer hay không
      // TODO xét trường hợp vào thẳng những trang ko footer
      if (nextProps.location && (!this.props.location || nextProps.location.pathname !== this.props.location.pathname)) {
        var listPath = nextProps.location.pathname.split('/');
        var firstPathComponent = '';
        if (listPath.length > 1) {
          firstPathComponent = listPath[1];
        }
        if (listPath[2] === 'danh-gia') {
          var hasFooter = routeNoFooter.indexOf(listPath[2]) === -1;
          var hasHeader = routeNoHeader.indexOf(firstPathComponent) === -1;
          this.refs.app.scrollTop = 0;
          this.setState({ hasHeader: hasHeader, hasFooter: hasFooter });
        } else if (listPath[1] === 'uu-dai' && listPath.length === 3) {
          var _hasFooter4 = routeNoFooter.indexOf(firstPathComponent) === -1;
          this.refs.app.scrollTop = 0;
          this.setState({ hasHeader: true, hasFooter: _hasFooter4, onlyBanner: true });
        } else if (listPath[1] === 'khuyen-mai') {
          var _hasFooter5 = routeNoFooter.indexOf(firstPathComponent) === -1;
          this.refs.app.scrollTop = 0;
          this.setState({ hasHeader: true, hasFooter: _hasFooter5, onlyBanner: true });
        } else {
          var _hasFooter6 = routeNoFooter.indexOf(firstPathComponent) === -1;
          var _hasHeader2 = routeNoHeader.indexOf(firstPathComponent) === -1;
          this.refs.app.scrollTop = 0;
          this.setState({ hasHeader: _hasHeader2, hasFooter: _hasFooter6, onlyBanner: false });
        }
        if (location.query && location.query.hideHeader) {
          this.setState({
            hasFooter: false,
            hasHeader: false
          });
        }
      }
      if (!(0, _lodash.isEqual)(this.props.routes, nextProps.routes)) {
        this.setState({ routes: nextProps.routes });
      }
      // Set new header title for Uu-dai-goi
      if (!(0, _lodash.isEqual)(this.props.REWARD_CAMPAIGN, nextProps.REWARD_CAMPAIGN) && this.props.REWARD_CAMPAIGN && nextProps.REWARD_CAMPAIGN && nextProps.REWARD_CAMPAIGN.data && nextProps.REWARD_CAMPAIGN.data[0]) {
        configHeader.title = nextProps.REWARD_CAMPAIGN.data[0].campaign.name;
        this.forceUpdate();
      }
    }
  }, {
    key: 'appClass',
    value: function appClass() {
      var styles = require('./AppMobile.scss');
      var _state = this.state,
          hasFooter = _state.hasFooter,
          hasHeader = _state.hasHeader,
          filterFullScreen = _state.filterFullScreen;

      if (!hasFooter && !hasHeader || filterFullScreen) {
        return ' ' + styles.fullHeight;
      }
      if (!hasHeader) return ' ' + styles.noHeader;
      if (!hasFooter) return ' ' + styles.noFooter;
      return '';
    }
  }, {
    key: 'onFocus',
    value: function onFocus() {
      this.setState({ focus: true });
    }
  }, {
    key: 'onBlur',
    value: function onBlur() {
      this.setState({ focus: false });
      document.activeElement.blur();
    }
  }, {
    key: 'scrollToHandleBanner',
    value: function scrollToHandleBanner() {
      if (this.bannerHidden) return;
      if (window.pageYOffset > 150) {
        if (this.state.hasBanner) {
          this.setState({
            hasBanner: false
          });
        }
      } else if (window.pageYOffset < 50) {
        if (!this.state.hasBanner) {
          this.setState({
            hasBanner: true
          });
        }
      }
    }
  }, {
    key: 'moreDetailBanner',
    value: function moreDetailBanner() {
      this.onClosePopupImage();
      this.props.history.push('/khuyen-mai/tang-gel-rua-tay-50ml');
    }
  }, {
    key: 'appContentStyle',
    value: function appContentStyle() {
      var _state2 = this.state,
          hasBanner = _state2.hasBanner,
          hasHeader = _state2.hasHeader,
          onlyBanner = _state2.onlyBanner;
      var pathname = this.props.location.pathname;

      if (hasBanner && hasHeader) {
        if (pathname !== '/') {
          if (onlyBanner) return { paddingTop: '40px' };
          return { paddingTop: '100px' };
        }
        return { paddingTop: '40px' };
      } else if (!hasBanner && hasHeader) {
        if (pathname !== '/') {
          if (onlyBanner) return { paddingTop: '0px' };

          return { paddingTop: '57px' };
        }
        return { paddingTop: '0px' };
      }
      return { paddingTop: '0px' };
    }
  }, {
    key: 'render',
    value: function render() {
      // throw new Error('Error');
      var styles = {};
      if ((0, _lib.isMobile)()) {
        styles = require('./AppMobile.scss');
      }
      var _state3 = this.state,
          hasFooter = _state3.hasFooter,
          hasHeader = _state3.hasHeader,
          routes = _state3.routes,
          focus = _state3.focus,
          onlyBanner = _state3.onlyBanner;
      var pathname = this.props.location.pathname;
      // tranfer param to banner to generate dynamic link

      var handle = void 0;
      if (this.props.params.id) {
        // for shop
        handle = this.props.params.id;
      } else if (this.props.params.handle) {
        // for collection
        handle = this.props.params.handle;
      } else if (this.props.params.voucherId) {
        // for voucher
        handle = this.props.params.voucherId;
      }
      return _react2.default.createElement(
        'div',
        { className: styles.app },
        _react2.default.createElement(_DownloadAppPopup2.default, null),
        _react2.default.createElement(
          _components.Boundary,
          null,
          _react2.default.createElement(_reactHelmet2.default, _config2.default.app.head),
          _react2.default.createElement(_reactHelmet2.default, { meta: [{ property: 'og:url', content: _config2.default.siteUrl }] }),
          (hasHeader || onlyBanner || pathname === '/') && _react2.default.createElement(
            'div',
            { className: styles.banner },
            _react2.default.createElement(_components.HeaderBanner, {
              handle: handle,
              pathname: pathname,
              showBanner: this.state.hasBanner,
              closeBanner: this.onCloseBanner
            }),
            !onlyBanner && pathname !== '/' && hasHeader && _react2.default.createElement(_components.HeaderMobile, {
              routes: routes,
              config: this.props.configHeader,
              history: this.props.history,
              location: this.props.location,
              pathname: pathname,
              onFocus: this.onFocus.bind(this),
              onBlur: this.onBlur.bind(this)
            })
          ),
          focus && _react2.default.createElement('div', {
            className: styles.bgCover,
            onClick: this.onBlur.bind(this),
            onTouchMove: this.onBlur.bind(this)
          }),
          _react2.default.createElement(
            'div',
            {
              id: 'app-content',
              ref: 'app',
              className: styles.appContent + this.appClass.call(this),
              style: this.appContentStyle()
            },
            this.props.children
          ),
          hasFooter && _react2.default.createElement(_components.FooterMobile, {
            manualTrack: this.props.manualTrack,
            noti: this.state.noti,
            pathCurrent: this.props.location && this.props.location.pathname || '/'
          })
        )
      );
    }
  }]);
  return AppMobile;
}(_react.Component), _class2.propTypes = {
  routes: _react.PropTypes.array,
  notifications: _react.PropTypes.array,
  loadNotification: _react.PropTypes.func.isRequired,
  history: _react.PropTypes.object,
  params: _react.PropTypes.object,
  location: _react.PropTypes.object,
  configHeader: _react.PropTypes.object,
  categories: _react.PropTypes.array,
  children: _react.PropTypes.object.isRequired,
  user: _react.PropTypes.object,
  pathname: _react.PropTypes.string,
  filterFullScreen: _react.PropTypes.bool,
  REWARD_CAMPAIGN: _react.PropTypes.object,
  PACKAGE_DETAIL: _react.PropTypes.object,
  // @action
  pushState: _react.PropTypes.func.isRequired,
  setPathName: _react.PropTypes.func.isRequired,
  changeHeader: _react.PropTypes.func,
  loadAuth: _react.PropTypes.func,
  loginFacebook: _react.PropTypes.func,
  setUser: _react.PropTypes.func,
  // saveUserLocation: PropTypes.func,
  loadCat: _react.PropTypes.func,
  manualTrack: _react.PropTypes.func
}, _class2.contextTypes = {
  store: _react.PropTypes.object.isRequired
}, _temp)) || _class) || _class);
exports.default = AppMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/AppMobile.js
// module id = 1661
// module chunks = 0